import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { ResponseData } from 'models';
import moment from 'moment';
import React, { useState } from 'react';
import { formatArray } from 'utils/common';
import ChartOutputEnergy from '../ChartOutputEnergy/ChartOutputEnergy';
import style from './OutputEnergy.module.scss';
export interface OutputEnergyProps {
  //   optionSelect: any;
}

export default function OutputEnergy(props: OutputEnergyProps) {
  //   const { optionSelect } = props;
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const date = moment().format('YYYY-MM-DD');
  const [dataChart, setDataChart] = useState<ResponseData[]>();

  React.useEffect(() => {
    if (inverterId) {
      fetchDataInverterChart('hourly', date);
    }
  }, [inverterId]);

  const fetchDataInverterChart = async (type: string, date: string) => {
    const response: ResponseData[] = await InverterApi.fetchStatisticByTime({
      id: inverterId,
      type: 'output-energy',
      typeTime: type,
      dateTime: date,
    });
    setDataChart(formatArray(response));
  };

  return (
    <div className={style.root}>
      <div className={style.label_container}>Output Energy</div>
      <div className={style.device_line_chart}>
        {dataChart && (
          <ChartOutputEnergy
            dataChart={dataChart}
            fetchDataInverterChart={fetchDataInverterChart}
          />
        )}
      </div>
    </div>
  );
}
